$(document).ready(function () {

    $('.timepicker').timepicker({
        showInputs: false,
        defaultTime: '00:00',
        disableFocus: true,
        format: 'HH:mm',
        template: 'dropdown',
        showMeridian: false
    }).attr("placeholder", "  :  ");

    $('.datepicker').parent('.input-group').addClass('date').datepicker({
        language: 'pt-BR',
        format: 'dd/mm/yyyy',
        autoclose: true,
        todayHighlight: true
    });

    $(".spinner").each(function (index) {
        $(this).TouchSpin({
            verticalbuttons: true,
            max: $(this).attr("max"),
            min: $(this).attr("min")
        });

        $(this).on('keyup', function () {
            this.value = this.value.replace(/[^0-9]+/g, '');
        });
    });

    $('.btn-open-modal').each(function (index, item) {
        var url = item.getAttribute("url");
        var modalId = item.getAttribute("elementId");
        $(document).ready(function () {
            if ($("#" + modalId).length === 0) {
                $('body').append('<div id="' + modalId + '"></div>');
            }
            $("#" + modalId).load(url);
        });

    });


    $('.data').mask('00/00/0000');

    $('.anoSem').mask('0000/0', {placeholder: "____/_"});

    $('.mask').each(function (index) {
        $(this).mask($(this).attr("mask"));
    });

});
